import { render, staticRenderFns } from "./shopSaleStatIndexRealTime.vue?vue&type=template&id=04fa8547&"
import script from "./shopSaleStatIndexRealTime.vue?vue&type=script&lang=js&"
export * from "./shopSaleStatIndexRealTime.vue?vue&type=script&lang=js&"
import style0 from "./shopSaleStatIndexRealTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports